import { getApiBaseUrl } from '@utils/apiBaseUrl'

export interface ExitDemoLeadPayload {
  email: string
  heroVariant?: number
}

export async function submitExitDemoLead(payload: ExitDemoLeadPayload): Promise<void> {
  const url = `${getApiBaseUrl()}/public/demo-video-lead`
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: true,
  })

  if (!response.ok) {
    throw new Error(`demo-video-lead failed: ${response.status}`)
  }
}
